import { epic$, store } from '@redux/store';
import housingProductLocationContentSlice from './redux/slice';
import fetchHousingProductLocationContentEpic from './redux/epics';
import { selectFetchStatus, selectRequestStatus } from './redux/selectors';

const { actions: housingProductLocationContentActions, reducer } = housingProductLocationContentSlice;
epic$.next(fetchHousingProductLocationContentEpic);
store.injectReducer('housingProductLocationContent', reducer);

require('./components/snippetContentHandler');
require('./components/breadcrumbContentHandler');
require('./components/housingProductLocationContentHandler');
require('./components/linkModulesHandler');

export { 
    housingProductLocationContentActions, 
    selectFetchStatus as selectHousingProductLocationFetchStatus,
    selectRequestStatus
 };
